<template>
    <footer>
        <div class="foot_counten">
          <div v-for="(items, groupName) in footerData" :key="groupName" class="footer-group">
            <h3>{{ groupName }}</h3>
            <ul>
              <li v-for="item in items" :key="item.name">
                <a :href="item.link" :title="item.name" target="_blank" rel="noopener">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <p class="copyright">COPYRIGHT © 2000-2021 SANGFOR TECHNOLOGIES. ALL RIGHTS RESERVED.</p>
      </footer>
</template>

<script>
import defaultFooterData from '@/data/sangfor-footer.json';

export default {
  data() {
    return {
      footerData: defaultFooterData
    };
  }
};
</script>

<style scoped lang="scss">
    footer{
      width: 100%;
      background: #232949;
      .foot_counten{
        width: 100%;
        display: flex;
        padding: 0 200px;
        margin: 0 auto;
        justify-content: space-between;
        div{
          width: 12%;
          padding: 57px 0 28px 0;
          h3{
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-bottom: 20px;
            text-align: left;
          }
          ul{
            li{
              font-size: 14px;
              line-height: 26px;
              text-align: left;
              a{
                color: #77797E;
                  &:hover{
                  color: #FFFFFF;
                }
              }
            }
          }
        }
      }
      .copyright{
        padding: 10px 0;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
      }
    }
    ul,li{
    list-style: none;
    cursor: pointer;
    white-space: nowrap;
    margin: 0;
}
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, /* structural elements 结构元素 */
dl, dt, dd, ul, ol, li, /* list elements 列表元素 */
pre, /* text formatting elements 文本格式元素 */
fieldset, button, input, textarea, /* form elements 表单元素 */
th, td,div,header { /* table elements 表格元素 */
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
</style>